export const MuiFormControlLabel = {
  root: {
    marginLeft: 0,
  },
  label: {
    marginBottom: 0,
  },
};
